import payload_plugin_qLmFnukI99 from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import global_lifecycle_global_tHxxTIzlSJ from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/plugins/global-lifecycle.global.ts";
import i18n_VfGcjrvSkj from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/plugins/i18n.ts";
import pinia_persist_client_hF1a8JFMAT from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/plugins/pinia-persist.client.ts";
import set_title_global_pOQZ3WKfza from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/plugins/set-title.global.ts";
import vuetify_7h9QAQEssH from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/plugins/vuetify.ts";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  global_lifecycle_global_tHxxTIzlSJ,
  i18n_VfGcjrvSkj,
  pinia_persist_client_hF1a8JFMAT,
  set_title_global_pOQZ3WKfza,
  vuetify_7h9QAQEssH
]